import React from 'react';

export const RATING_CONFIG = {
  size: 'medium',
  edit: false,
  emptyIcon: <i className="far fa-star" />,
  filledIcon: <i className="fa fa-star" />,
};
